module.exports = __webpack_public_path__ + "static/media/14.e1c99501.jpg";